import { useState } from "react";
import { Modal } from "./ui/dialog";
import { Button } from "./ui/button";
import { Field, Textarea } from "./ui/field";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  title: string;
  description?: string;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

export function ReasonDialog({ open, title, description, pending, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const valid = reason.trim().length > 0;
  return (
    <Modal open={open} onOpenChange={(o) => !o && onCancel()} title={title} description={description}>
      <Field label={t("reasonDialog.reason")} htmlFor="reason">
        <Textarea id="reason" value={reason} onChange={(e) => setReason(e.target.value)} />
      </Field>
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" onClick={onCancel}>{t("common.cancel")}</Button>
        <Button disabled={!valid || pending} onClick={() => onConfirm(reason.trim())}>{t("common.confirm")}</Button>
      </div>
    </Modal>
  );
}
